import styled from 'styled-components';
import {Container, Popover} from 'react-bootstrap';
import {controlWithIcon} from '../../../common/shared/control-with-icon.styled';
import {pageTitle} from '../../../common/shared/pageTitle.styled';
import { StyledModal } from '../../../common/shared/modal.styled';
import background from '../../../images/newDesign/background.png';
import checked from '../../../images/managers/check.svg';

export const StyledDebtList = styled.div`
  ${controlWithIcon()}
  ${pageTitle()}

  #section-to-print {
    width: 100%;
  }
  
  .hidden-section {
    visibility: collapse;
    height: 1px;
    width: 1px;
    position: fixed;
  }

  .title-wrapper {
    display: flex;
    justify-content: space-between;
    margin-inline-end: 170px;

    .icons-bar {
        margin-top: 8px;
    }
  }
  
  &.building-debt {
    max-width: none;
  }
  .title-section h2 {
    margin-bottom: 0;
  }

  #table {
    max-height: 500px;
  
    tr {
      td.send-request {
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
      }
    }
  }
 
  .tool {
    width: 32px;
    height: 32px;
    background-color: #E9E9FD;
    border-radius: 50px;
    cursor: pointer;
    transform: rotate(-90deg);
    color: var(--bllink-purple);
    font-weight: 600;

    :hover {
      background: linear-gradient(180deg, #6E8EFF 0%, #8469FF 100%);
      color: #FFFFFF;
    }
  }

  .back-link {

    a {
      display: flex;
      align-items: center;
      color: var(--bllink-gray);
    }

    img {
      margin-inline-end: 10px;
      transform: ${({ltr}) => ltr ? 'rotate(180deg)' : ''}
    }
  }

  .bllink-input-border {
    padding-left: 60px;
  }

  .title_wrapper {
    display: flex;
    gap: 5px;
  }

  .send-all-button {
    margin: 0 50px;
    width: 300px;
  }
`;

export const StyledLetter = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 1300px;
  direction: rtl;
  text-align: right;
  opacity: 0;
  background-color: #fff;
  transform: scale(1.15);
  .letter-container {
    padding: 95px;
    font-size: 18px;
    background-color: #fff;
  }

  .apartment-data {
    margin-bottom: 40px;
  }
  h2 {
    font-size: 26px;
    margin-bottom: 40px;
  }

  h4 {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .legal-text {
    display: inline;
    background-color: #FFC61C;
  }

  p {
    span + span {
      margin: 0 5px;
    }
  }

  div + div:not(.logo-top) {
    margin-top: 50px;
  }

  .logos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding: 0 15px;

    .empty {
      display: none;
    }

    img {
      width: 100%;
    }

    .logo-top {
      width: 85px;
    }

    .partner {
      width: 85px;
    }
  }
`;

export const StyledLetterNew = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 1300px;
  opacity: 0;
  background-color: #fff;
  font-family: var(--bllink-font-tertiary);
  
  .letter-container {
    font-size: 25px;
    // TODO: make direction dynamic when localization is ready
    direction: rtl;
    padding: 70px 150px;
    width: 100%;
    background: url(${background}) no-repeat right 1000px top 30%, url(${background}) no-repeat 20px 25%  / 300px;

    .header {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      width: 100%;
      margin-bottom: 70px;

      .logo {
        height: 150px;
        display: flex;
        justify-content: flex-end;

        img {
          height: 100%;
        }
      }
    }

    .user-info {
      margin-bottom: 30px;
    }

    .notice {
      border-bottom: 7px solid var(--bllink-purple);
      padding-bottom: 20px;
      margin-bottom: 40px;
      font-size: 30px;
    }

    .highlitedItem {
      background-color: yellow;
    }

    .list, .subList {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .margin-to-break-pages {
        margin-bottom: 220px;
      }
    }

    .list {
      margin-top: 20px;
      margin-inline-start: 20px;
      .total {
        text-align: center;
        font-size: 35px;
        margin: 20px auto;
      }

      .subItem {
        margin: 0 40px;
      }
    }

    .bold {
      font-weight: 900;
    }

    .extra-info {
      margin-top: 20px;
    }
  }

  .table-wrapper {
    table {
      width: 100%;
      table-layout: fixed;
      border: thick double black;
      margin: 35px 0;
      
      tr {
        border-top: thick double black;
        
        td {
          padding: 40px 0;
          text-align: center;
          width: 100%;
        }
      }
  
      thead {
        background-color: var(--bllink-purple);
        color: #FFFFFF;

        tr {
          border-top: none;
        }
      }
    }
  }
`

export const StyledPopover = styled(Popover)`
  border-radius: 19px;
  padding: 0;
  border: none;
  box-shadow: 0px 0px 17px 0px rgba(34, 60, 80, 0.2);

  .popover-body {
    padding: 10px 0;
    width: 220px;
    
    .link {
      cursor: pointer;
      padding: 10px 17px;
      position: relative;
      border: none;
      background-color: transparent;
      width: 100%;
      text-align: start;
  
      &:hover {
        background: ${({ ltr }) => ltr ? 'linear-gradient(90deg, rgba(139, 117, 245, 0.15) 0%, rgba(196, 196, 196, 0) 80%, rgba(196, 196, 196, 0) 100%)' : 'linear-gradient(90deg, rgba(196, 196, 196, 0) 0%, rgba(139, 117, 245, 0.15) 169.34%)'};
        color: var(--bllink-purple);
        font-weight: 700;

        :before {
          content: "";
          position: absolute;
          right: ${({ ltr }) => ltr ? '' : '0'};
          left: ${({ ltr }) => ltr ? '0' : ''};
          top: 50%;
          width: 4px;
          height: 80%;
          background-image: linear-gradient(360deg, #6798FF 0%, #8C5CFF 100%);
          box-shadow: 0px 0px 5px rgba(139, 117, 245, 0.4);
          border-radius: ${({ ltr }) => ltr ? '0px 8px 8px 0px' : '8px 0px 0px 8px'};;
          transform: translateY(-50%);
        } 
        
        a {
          color: var(--bllink-purple);
          text-decoration: none;
        }
      }

      a {
        color: #212529;
      }
    }
  }


  .link.disabled {
    pointer-events: none;
    color: rgba(55, 54, 71, 0.5);

    a {
      color: rgba(55, 54, 71, 0.5);
    }
  }
`;

export const StyledDebtModal = styled(StyledModal)`
  .close-btn {
    height: 20px;
    font-weight: 300;
    font-size: 36px;
    line-height: .5;
    cursor: pointer;
  }

  .modal-body {
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 40px;
    }

    h4 {
      text-align: center;
    }

    h5 {
      width: fit-content;
      margin-bottom: 20px;
      font-size: 19px;
    }

    .success-img {
      height: 300px;
    }
  }

  .bllink-button {
    align-self: center;
    margin-top: 20px;
  }

  .columns {
    display: grid;
    grid-template-columns: 3.5fr 2fr 2fr 0.5fr;
    gap: 20px;

    .wrapper {

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 13px;
      color: rgba(55, 54, 71, 0.7);

      .header {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 15px;
        display: flex;
        gap: 12px;
        align-items: center;
        color: #373647;
      }

      .name-wrapper {
        display: flex;
        gap: 20px;
      }

      .bllink-input-border {
        height: 35px;
      }
    }


    .edit-icon {
      border: 1px solid #A8C0FF;
      height: fit-content;
      width: fit-content;
      display: flex;
      padding: 8px;
      border-radius: 50px;
      cursor: pointer;
    }
  }

  .modal-header {
    background: linear-gradient(90deg, #6895FF 1.74%, #8C5CFF 100.15%);
    border-radius: 25px 25px 0 0;
    color: #FFFFFF;
  }
`;

export const StyledTenantNotificationModal = styled(StyledModal)`
  .modal-dialog{
    max-width: 750px;
  }

  .modal-content {
    width: 750px;
    height: fit-content;
    text-align: ${({ ltr }) => ltr ? 'end' : 'start'};
    font-family: var(--bllink-font-primary);
    background: #F9F9FF;
  }
  
  .close-btn {
    height: 17px;
    font-weight: 300;
    font-size: 36px;
    line-height: .5;
    cursor: pointer;
    position: absolute;
    right: 26px;
    top: 20px;
    filter: invert(.5);
  }
  
  .modal-body {
    display: flex;
    flex-direction: column;
    width: 750px;
    padding: 14px 23px !important;
    color: rgba(55, 54, 71, 0.7);

    h4 {
      font-weight: 700;
      letter-spacing: 0.035em;
      text-align: center;
    }

    p {
      margin: 0;
    }

    .main-active-box {
      display: flex;
      justify-content: space-between;
      margin-block-start: 16px;
      margin: 26px 20px 0;
      
      font-size: 17px;
      font-weight: 700;
      letter-spacing: 0.04em;
      
      .select-apps {
        margin-top: 38px;
        font-size: 14px;
        font-weight: 400;
        text-align: start;
        
        span {
          font-size: 17px;
          font-weight: 700;
          line-height: 20px;
        }
        
        div {
          display: flex;
          margin-block-start: 15px;
          
          input {
            border-radius: 10px;
            appearance: none;
            width: 22px;
            height: 19px;
            border: 1px solid #6F8BFF;
            margin-inline-end: 15px;
          }

          input:checked {
            background-color: #6F8BFF;
            background-image: url(${checked});
            background-repeat: no-repeat;
            background-position: center;
            background-size: 11px;
            border: none;
          }

          input:disabled{
            border: 1px solid rgba(125, 125, 128, .5);
          }

          input:disabled + label{
            color: rgba(125, 125, 128, .5);
          }
        }
      }
    }

    .notification-modal-top {
      margin-block-end: 20px;
    }

    .notification-modal-content {
      margin: 0 20px;
      padding-block-end: 22px;
      line-height: 22px;
      font-size: 14px;
      border-block-end: 1px solid #D8D2FF;

      .bold {
        font-size: 16px;
        letter-spacing: 0.04em;
      }

      #author {
        margin-block-start: 8px;
      }

      #help {
        margin-block-start: 6px;
        font-size: 12px;
      }

      a {
        letter-spacing: 0.04em;
      }
    }
  }
  
  .modal-icon {
    margin-block-end: 14px;
  }
  
  .tenant-request-submit {
    align-self: ${({ltr}) => ltr ? 'start' : 'end'};
  }
  
  .bllink-button {
    align-self: center;
    margin: 34px 11px;
    width: 134px;
    height: 44px;
    border-radius: 8px;
    font-size: 15px;
    line-height: 18px;
  }
`;
